<template>
    <div class="novo-formulario">
        <container-loader
            v-if="isLoading && !$store.getters.isLoading"
        />
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        isUpdate &&
                        permissao.create &&
                        $route.name != `${abrev}formulario-duplicate-new`
                    "
                    class="delete-btn duplicate-form"
                    type="button"
                    tag="button"
                    @click="editToDuplicate()"
                    v-tippy 
                    :title="$t('duplicar-formulario')"
                >
                    <b-icon icon="content-copy" />
                </button>
                <button
                    v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                    class="save-btn"
                    type="button"
                    @click="saveForm"
                    :disabled="!canEdit || isSaving"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <div class="page-container form-columns-fit">
            <div class="columns is-multiline">
                <div class="column is-2 pb-0">
                    <v-input :id="'codigo'" ref="idformularioerpInput" v-model="formulario.idform_formularioerp"
                        placeholder="placeholder-preencha" :maxlength="30" title="codigo" uppercase required
                        :invalid="!formulario.idform_formularioerp" tooltipLabel="cod-ref" />
                </div>
                <div class="column is-8 pb-0">
                    <v-input
                        :id="'titulo'"
                        v-model="formulario.titulo"
                        :placeholder="'titulo-do-formulario-placeholder'"
                        :maxlength="50"
                        :title="'titulo-do-formulario'"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!formulario.titulo"
                        ref="tituloInput"
                        :uppercase="false"
                        :required="true"
                    />
                </div>
                <div class="column is-2 pb-0">
                    <label v-text="$t('modulo')" />
                    <v-select 
                        ref="moduloSelect" 
                        :searchable="false" 
                        :options="modulos"
                        :value="modulo" 
                        :getOptionLabel="getLabel"
                        @input="updateModulo" 
                        class="no-clear"
                    >
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>
                <div class="column is-12 pb-0">
                    <v-input
                        v-model="formulario.descricao_geral"
                        :id="'descricao'"
                        :placeholder="'descricao-do-formulario-placeholder'"
                        :maxlength="100"
                        :title="'descricao-do-formulario'"
                        :msg="'msg-campo-obrigatorio'"
                        :invalid="!formulario.descricao_geral"
                        ref="descricaoInput"
                        :uppercase="false"
                        :required="true"
                    />
                </div>
            </div>
        </div>
        <div class="mt-4 mb-4">
                <template v-for="(formGrupoPergunta, i) in formulario.formGrupoPerguntaList">
                    <div
                        class="grupo page-container"
                        :class="{
                            'invalid':
                                isNull(formGrupoPergunta.descricao) || !getValidadaFormGrupoPergunta(formGrupoPergunta),
                        }"
                        v-if="formGrupoPergunta.datahoradel == undefined || formGrupoPergunta.datahoradel == null" 
                    >
                        <div 
                            class="grupo-container"
                        >
                            <div class="titulo-gp">
                                <div class="titulo-left">
                                    <label
                                        v-if="editing == i"
                                        for="titulo-gp"
                                        v-text="$t('titulo-do-gruopdeperguntas')"
                                        :class="{
                                            'invalid':
                                                isNull(formGrupoPergunta.descricao) ||
                                                !getValidadaFormGrupoPergunta(formGrupoPergunta),
                                        }"
                                    />
                                    <label
                                        v-else
                                        for="titulo-gp"
                                        :class="{
                                            invalid:
                                                isNull(formGrupoPergunta.descricao) ||
                                                !getValidadaFormGrupoPergunta(formGrupoPergunta),
                                        }"
                                        v-text="
                                            !isNull(formGrupoPergunta.descricao)
                                                ? formGrupoPergunta.descricao
                                                : $t('grupopergunta-sem-titulo')
                                        "
                                    />
                                </div>
                                <div class="titulo-right">
                                    <button 
                                        v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)" 
                                        class="edit-button" 
                                        type="button" 
                                        @click="editing = i"
                                    >
                                        {{ $t('editar-grupo-perguntas') }}
                                    </button>
                                    <button
                                        v-if="(permissao.create)"
                                        class="edit-button"
                                        type="button"
                                        @click.prevent="excluirGPModal(i)"
                                    >
                                        {{ $t('excluir-grupo-perguntas') }}
                                    </button>
                                </div>
                            </div>
                            <div class="titulo-gp-input">
                                <v-input
                                    v-if="editing == i"
                                    v-model="formGrupoPergunta.descricao"
                                    title="titulo-do-gruopdeperguntas"
                                    msg="msg-campo-obrigatorio"
                                    id="titulo-gp"
                                    placeholder="titulo-do-gruopdeperguntas-placeholder"
                                    :maxlength="255"
                                    :invalid="isNull(formGrupoPergunta.descricao)"
                                    :ref="`tituloGPInput-${i}`"
                                    :onBlurFunction="() => (editing = false)"
                                    :uppercase="false"
                                />
                            </div>
                            <ConfiguraCampos
                                @isLoading="setLoading" 
                                @reload="reloadPageAfeterRequest"
                                :formPerguntaList="formGrupoPergunta.formPerguntaList"
                                :index="i"
                                :ref="`conf-campos-${i}`"
                                :contexto="contexto"
                                :isUpdate="isUpdate"
                                :permissao="permissao"
                                @isChanged="
                                    $emit('isChanged', $event); 
                                    canEdit = true;
                                "
                            />
                        </div>
                    </div>
                </template>
            <button type="button" class="btn add-campos mb-4" @click="addFormGrupoPergunta()">
                <p>
                    <svg class="svg-icons">
                        <use
                            :xlink:href="require('@/assets/img/icons/shape-plus.svg') + '#layer'"
                        ></use>
                    </svg>
                    {{ $t('novo-grupo-perguntas') }}
                </p>
            </button>
        </div>
    </div>
</template>

<script>
import FormFormularioService from "@/services/FormFormularioService.js";
import FormGrupoPerguntaService from "@/services/FormGrupoPerguntaService.js";
import ConfiguraCampos from '@/components/promotor/formulario/abas/ConfiguraCampos.vue';
import FormularioValidation from '@/services/validations/FormularioValidation.js';
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ConfiguraCampos,
        ContainerLoader
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isSaving: false,
            formulario: {
                id: null,
                idform_formularioerp: null,
                formGrupoPerguntaList: [],
                situacao: 1,
            },
            formFormulario: {},
            deleteThis: null,
            editable: false,
            enabledDrag: false,
            editing: -1,
            modulos: [
                { label: "vendas", id: 0 }, 
                { label: "promotor", id: 1 },
                { label: "prestacao-servico", id: 2 }
            ],
            modulo: null,
            isLoading: false,
            canEdit: false,

            abrev: '',
            contexto: '',
            isVenda: this.$route.meta.contexto == 'vendas',
            isPromotor: this.$route.meta.contexto == 'promotor',
            isPrestacaoServico: this.$route.meta.contexto == 'prestacao-servico',
            serviceGrupoPergunta: new FormGrupoPerguntaService(this.$http, this.$router),
        };
    },
    created() {
        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 500);

        if (this.formulario != null && this.formulario != {}) this.editable = true;

        this.service = new FormFormularioService(this.$http, this.$router);
        this.validation = new FormularioValidation(this.$root.msgs);

        this.contexto = this.$route.meta.contexto.slice(0, 3);


        if (this.isPrestacaoServico) {
            this.permissao = this.hasPermissionAccess('prestacao-servico', 'formulario', 'serv-formulario');
            this.modulo = { label: "prestacao-servico", id: 2 };
            this.contexto = this.$route.meta.abrev;
            this.abrev = `${this.$route.meta.abrev}-`;
        } else if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'formulario');
            this.modulo = { label: "promotor", id: 1 };
        } else if (this.isVenda) {
            this.abrev = this.$route.meta.contexto.slice(0, 3) + '-';
            this.permissao = this.hasPermissionAccess('vendas', 'formulario', 'ven-formulario');
            this.modulo = { label: "vendas", id: 0 };
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'formularios' },
            });
        } else {
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'formularios' },
                });
            }
            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
            this.$on('update-grupoperguntas', this.updateFormGrupoPergunta);
        }
    },
    watch: {
        $route() {
            this.formulario = { formGrupoPerguntaList: [], situacao: 1 };
            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        },
        formulario: {
            deep: true,
            handler: function () {
                if (!this.isLoading) {
                    this.$emit('isChanged', true);
                    this.canEdit = true;
                }
            },
        },
    },
    mounted() {
        this.$refs.tituloInput.$refs.typed.focus();
    },
    methods: {
        mapFormRespostaItem(formRespostaItemList) {
            return formRespostaItemList.map(formRespostaItem => ({
                datahorainc: formRespostaItem.datahorainc,
                datahoraalt: formRespostaItem.datahoraalt,
                datahoradel: formRespostaItem.datahoradel,
                id: formRespostaItem.id,
                idform_resposta_itemerp: formRespostaItem.idform_resposta_itemerp,
                uuid: formRespostaItem.uuid,
                id_form_pergunta: formRespostaItem.id_form_pergunta,
                descricao: this.mapToSavePreserveCase(formRespostaItem.descricao),
                habilita_foto: formRespostaItem.habilita_foto,
                situacao: formRespostaItem.situacao
            }));
        },
        mapToFormFormulario() {
            const formGrupoPerguntaList = this.formulario.formGrupoPerguntaList.map(formGrupoPergunta => ({
                id: formGrupoPergunta.id,
                uuid: formGrupoPergunta.uuid,
                id_form_formulario: formGrupoPergunta.id_form_formulario,
                descricao: this.mapToSavePreserveCase(formGrupoPergunta.descricao),
                situacao: 1,
                datahoradel: formGrupoPergunta.datahoradel,
                formPerguntaList: formGrupoPergunta.formPerguntaList.map(formPergunta => ({
                    id: formPergunta.id,
                    uuid: formPergunta.uuid,
                    datahoradel: formPergunta.datahoradel,
                    id_form_grupo_pergunta: formPergunta.id_form_grupo_pergunta,
                    descricao: this.mapToSavePreserveCase(formPergunta.descricao),
                    imagem: "",
                    obrigatorio: formPergunta.obrigatorio,
                    situacao: 1,
                    item_tipo: 
                        formPergunta.formRespostaItemList && 
                        formPergunta.formRespostaItemList.length > 0 ? 
                        formPergunta.item_tipo : "",
                    formRespostaItemList: this.mapToFormRespostaItem(
                        formPergunta.formRespostaItemList ? 
                        this.mapFormRespostaItem(formPergunta.formRespostaItemList) : []
                    )
                }))
            }));

            return {
                id: this.formulario.id,
                uuid: this.formulario.uuid,
                idform_formularioerp: this.formulario.idform_formularioerp,
                formGrupoPerguntaList: formGrupoPerguntaList,
                titulo: this.mapToSavePreserveCase(this.formulario.titulo),
                descricao_geral: this.mapToSavePreserveCase(this.formulario.descricao_geral),
                url_externa_ativa: "",
                habilita_assinatura: 0,
                habilita_transcricao_pergunta: 0,
                modulo_vendas: this.modulo.id == 0 ? 1 : 0,
                modulo_promotor: this.modulo.id == 1 ? 1 : 0,
                modulo_prestacao_servico: this.modulo.id == 2 ? 1 : 0,
                modulo_despesa: this.modulo.id == 3 ? 1 : 0,
                modulo_agro: this.modulo.id == 4 ? 1 : 0,
                situacao: this.formulario.situacao,
                datahoradel: this.formulario.datahoradel,
            };
        },
        mapToFormRespostaItem(formRespostaItemList) {
            if (!formRespostaItemList || formRespostaItemList.length === 0) {
                // retornar valor padrao caso for 'TEXT', 'MULTITEXT', 'INTEGER', 'DECIMAL', 'PERCENT' ou 'DATE'
                return [{
                    descricao: "Resposta: ",
                    situacao: 1, 
                    habilita_foto: 0 
                }];
            }

            return formRespostaItemList
        },
        setLoading(loading) {
            this.isLoading = loading;
        },
        reloadPageAfeterRequest() {
            this.carregarDados(this.$route.params.id);
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id, this.contexto)
                .then(body => {
                    this.formulario = body.content;
                    if (this.$route.name == `${this.abrev}formulario-duplicate-new`) this.duplicateFormFix();
                }).catch(e => {
                    console.error('[GERAL] Erro ao carregar formulário.', e);
                }).finally(() => {
                    setTimeout(() => {
                        this.$emit("isChanged", false);
                    }, 300);

                    this.$emit("titulo", this.formulario.titulo);

                    this.isLoading = false;
                });
        },
        duplicateFormFix() {
            delete this.formulario.id;
            delete this.formulario.idform_formularioerp;
            delete this.formulario.titulo;
            delete this.formulario.datahoraalt;
            delete this.formulario.datahorainc;

            this.formulario.formGrupoPerguntaList.forEach((formGrupoPergunta) => {
                delete formGrupoPergunta.id;
                delete formGrupoPergunta.id_form_formulario;
                delete formGrupoPergunta.datahoraalt;
                delete formGrupoPergunta.datahorainc;

                formGrupoPergunta.formPerguntaList.forEach((formPergunta) => {
                    delete formPergunta.id;
                    delete formPergunta.id_form_grupo_pergunta;
                    delete formPergunta.datahoraalt;
                    delete formPergunta.datahorainc;

                    formPergunta.formRespostaItemList.forEach((formRespostaItem) => {
                        delete formRespostaItem.datahoraalt;
                        delete formRespostaItem.datahorainc;
                        delete formRespostaItem.id_form_pergunta;
                        delete formRespostaItem.id;
                    })

                })

            })
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        updateModulo(modulo) {
            if (modulo && modulo.id != null) {
                this.modulo = modulo;
            }
        },
        getModulo(content) {
            const moduloMap = {
                modulo_vendas: 0,
                modulo_promotor: 1,
                modulo_prestacao_servico: 2,
                modulo_despesa: 3,
                modulo_agro: 4
            };

            for (const prop in moduloMap) {
                if (content[prop]) {
                    return this.modulos[moduloMap[prop]];
                }
            }
        },
        addFormGrupoPergunta() {
            this.editing = this.formulario.formGrupoPerguntaList.length;
            this.formulario.formGrupoPerguntaList.push({
                datahorainc: null,
                descricao: null,
                situacao: 1,
                formPerguntaList: []
            });
        },
        saveForm() {
            if (this.$refs.tituloInput != undefined) this.$refs.tituloInput.focusedOut = true;
            this.formulario.formGrupoPerguntaList.forEach((formGrupoPergunta, i) => {
                if (this.$refs[`tituloGPInput-${i}`] != undefined) {
                    if (this.$refs[`tituloGPInput-${i}`].length > 0) {
                        this.$refs[`tituloGPInput-${i}`][0].focusedOut = true;
                    }
                }
            })

            if (this.validation.validate(this.formulario, this.$refs)) {

                this.formFormulario = this.mapToFormFormulario()

                this.isSaving = true;
                this.service.save(this.formFormulario, this.contexto)
                .then(body => {
                    if (body.status != 200) {
                        if (body.message) {
                            if (body.message == "msg-codigo-duplicado-n") {
                                this.$root.showMessage(
                                    "alert", 
                                    this.$t(body.message, { n: this.formFormulario.idform_formularioerp }), 
                                    true, false
                                );
                            } else {
                                this.$root.showMessage("alert", body.message, true);
                            }
                        } else {
                            console.error(`${body.status}: ${body.message}`);
                            let msg = body.message != '' ? body.message : 'msg-problema-realizar-acao';
                            this.$root.showMessage("error", msg);
                            this.isSaving = false;
                        }
                    } else {
                        // Mudar para alerta padrão, quando o mesmo for criado
                        let msg = "msg-formulario-cadastrado";
                        if (this.formFormulario.id) msg = "msg-formulario-editado";


                        this.$root.showMessage("success", msg);

                        setTimeout(() => {
                            this.$emit("isChanged", false);
                            this.$emit("idFormulario", body.content.id);
                            if(body.content.id != +this.$route.params.id) {
                                this.$emit("redirect");
                            }
                        }, 500);
                    }
                })
                .catch(e => {
                    console.error('Erro ao salvar formulário.', e);
                    this.$root.showMessage("error", 'msg-problema-realizar-acao');
                })
                .finally(_ => {
                    this.isSaving = false;
                });
            } else {
                this.$root.showMessage(
                    "alert",
                    "msg-campos-obrigatorios",
                    true
                );
            }
        },
        excluirFormGrupoPergunta() {
            if (
                this.isNull(this.formulario.formGrupoPerguntaList[this.deleteThis].id) || 
                this.formulario.formGrupoPerguntaList[this.deleteThis].id == 0
            ) {
                this.formulario.formGrupoPerguntaList.splice(this.deleteThis, 1);
            } else {
                this.formulario.formGrupoPerguntaList[this.deleteThis].datahoradel = new Date();
            }
            this.canEdit = true;
            this.$emit('isChanged', true);
            
            this.$forceUpdate();

            this.deleteThis = null;
        },
        excluirGPModal(i) {
            this.deleteThis = i;
            let msg = this.$t('msg-confirmacao-exclusao-grupo-n', { 
                n: this.formulario.formGrupoPerguntaList[i].descricao 
                    ? this.formulario.formGrupoPerguntaList[i].descricao 
                    : this.$t('vazio') 
            });
            this.$root.confirm({
                message: msg,
                onConfirm: this.excluirFormGrupoPergunta,
                onCancel: _ => this.deleteThis = null
            });
        },
        removePrompt() {
            this.deleteThis = null;
        },
        updateFormGrupoPergunta(ps, i) {
            this.$set(this.formulario.formGrupoPerguntaList[i], 'formPerguntaList', ps);
        },
        getValidadaFormGrupoPergunta(formGrupoPergunta) {
            let qtdPerg = 0;
            let valid = true;

            if (formGrupoPergunta.formPerguntaList != undefined && formGrupoPergunta.formPerguntaList.length > 0) {
                formGrupoPergunta.formPerguntaList.forEach(formPergunta => {
                    if (formPergunta.datahoradel == null || formPergunta.datahoradel == undefined) {
                        qtdPerg++;

                        if (this.isNull(formPergunta.descricao)) {
                            valid = false;
                        }

                        if (['SWITCH', 'RADIO', 'CHECKBOX', 'COMBOBOX'].includes(formPergunta.item_tipo)) {
                            if (formPergunta.formRespostaItemList.length == 0) {
                                valid = false;
                            } else {
                                formPergunta.formRespostaItemList.forEach(formRespostaItem => {
                                    if (this.isNull(formRespostaItem.descricao)) {
                                        valid = false;
                                    }
                                });
                            }
                        }
                    }
                });
            } else {
                return false;
            }

            return (qtdPerg > 0 && valid);
        },
        editToDuplicate() {

            setTimeout(() => {
                this.$emit("isChanged", false);
            }, 500);

            setTimeout(() => {
                this.$router.push({
                    name: `${this.abrev}formulario-duplicate-new`,
                    params: { id: this.$route.params.id },
                });
            }, 1000);
        }
    },
};
</script>
    
<style lang="scss" scoped>

.duplicate-form {
    min-width: 50px !important;
    padding-top: 10px;
    padding-bottom: 9px;
}

.novo-formulario {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
    height: 100%;
    padding-top: 0;

    >h1 {
        padding-top: 20px;
        margin-bottom: 40px;
    }
}


.grupo {
    width: 100%;
    background-color: #fefefe;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 15px;

    .grupo-container {
        width: 100%;
    }

    .gp-handle {
        display: inline-flex;
        margin-right: 10px;

        svg {
            transform: rotate(90deg);
        }
    }

    &.invalid {
        border: 1px solid $red-alert;
    }

}

.titulo-gp {
    display: flex;
    width: 100%;
    text-transform: uppercase;

    .titulo-left,
    .titulo-right {
        display: flex;
        width: 70%;
    }

    .titulo-right {
        justify-content: flex-end;
    }

    label {
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        font-size: 17px;
        color: $sovis-black;

        &.invalid {
            color: $red-alert;
            font-weight: 600;
        }
    }

    .edit-button {
        box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
        width: 30%;
        color: $darker-gray-color;
        font-size: 12px;
        text-align: center;
        padding: 15px 40px;
        border: none;
        border-radius: 6px;
        font-weight: 600;
        @include exclude-button();
        padding: 5px 15px;

        &:not(:first-child) {
            margin-left: 20px;
        }
    }
}

.titulo-gp-input {
    display: flex;
    width: 100%;

    .verified-input {
        margin-top: 10px;
        width: 100%;
    }
}

.add-campos {
    @include exclude-button();
    // position: absolute;
    // bottom: 10px;
    border-radius: 10px;
    padding: 10px 80px;
    text-align: center;
    box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
    border-radius: 6px;

    > p {
        display: flex;
        align-items: center;
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: $darker-gray-color;

        > svg {
            margin-right: 10px;
            fill: $light-gray-color;
        }
    }
}

.form-buttons {
    right: 0px;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}
</style>
    
